export const CREATE_ROUTE = "CREATE_ROUTE";
export const GET_ROUTES = "GET_ROUTES";
export const GET_ROUTE = "GET_ROUTE";
export const EDIT_ROUTE = "EDIT_ROUTE";
export const LOADING = "LOADING_ROUTE";
export const SIDE_LOADING = "SIDE_LOADING_ROUTE";
export const ERROR = "ROUTE_ERROR";
export const DELETE = "DELETE_ROUTE";
export const SYNCING = "SYNC_ROUTE";
